import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import enNs1 from './locales/en/translation.json'
import ruNs1 from './locales/ru/translation.json'

export const defaultNS = 'translation';

const resources = {
    en: {
        translation: enNs1
    },
    ru: {
        translation: ruNs1
    }
}

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: 'ru',
        // lng: 'ru',
        defaultNS,
        interpolation: {
            escapeValue: false,
        },
        resources,
        detection: {
            order: ["localStorage", "cookie"],
            caches: ["localStorage", "cookie"],
        },
    });

export default i18n;